module.exports = __webpack_public_path__ + "img/Super-Bike-Rentals.5d600c32.jpg";